export enum Roles {
	TEACHER = 1,
	STUDENT = 2,
	// SUPERADMIN = 3,
	StudentPlatformAdmin = 3,
	ADMIN = 4,
	MENTOR = 5,
	COMPANYADMIN = 8,
	PROCTORINGADMIN = 9,
	COMPANY_EDUCATOR_ADMIN = 14
}